<template>
  <a-modal v-model="visible" :width="720" :title="`${sourceId === null ? '创建' : '编辑'}质效看板`" :ok-button-props="{ props: { loading: loading } }" @cancel="close('cancel')" @ok="onSubmit">
    <a-form-model ref="form" layout="vertical" :rules="rules" :model="form">
      <a-row :gutter="16">
        <a-col class="gutter-row" :span="24">
          <a-form-model-item label="看板标题" prop="title">
            <a-input v-model="form.title" />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col class="gutter-row" :span="24">
          <a-form-model-item label="参与项目" prop="projects">
            <a-select v-model="form.projects" mode="multiple" show-search placeholder="请选择参与项目" :filter-option="utils.filterOption">
              <a-select-option v-for="project in projects" :key="project.id" :value="project.id">{{ project.name }} </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col class="gutter-row" :span="24">
          <a-form-model-item label="参与团队" prop="teams">
            <a-select v-model="form.teams" mode="multiple" show-search placeholder="请选择参与团队" :filter-option="utils.filterOption">
              <a-select-option v-for="item in teams" :key="item.id" :value="item.id">{{ item.name }} </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col class="gutter-row" :span="12">
          <a-form-model-item label="开始时间" prop="start_date">
            <a-date-picker v-model="form.start_date" value-format="YYYY-MM-DD" type="date" placeholder="开始时间" style="width: 100%" @change="onBlur('start_date')" />
          </a-form-model-item>
        </a-col>
        <a-col class="gutter-row" :span="12">
          <a-form-model-item label="结束时间" prop="end_date">
            <a-date-picker v-model="form.end_date" value-format="YYYY-MM-DD" type="date" placeholder="结束时间" style="width: 100%" @change="onBlur('end_date')" />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col class="gutter-row" :span="12">
          <a-form-model-item label="总分" prop="total_points">
            <a-input-number v-model="form.total_points" :min="1" :max="100" style="width: 60%" />
            <span> 分</span>
          </a-form-model-item>
        </a-col>
        <a-col class="gutter-row" :span="12" :label-col="{ span: 5 }" :wrapper-col="{ span: 5 }">
          <a-form-model-item label="时量分布(分值占比)" prop="time_quality">
            <a-input-number v-model="form.time_quality" :min="0" :max="100" :formatter="value => `${value}%`" :parser="value => value.replace('%', '')" style="width: 60%" />
            <span> {{ parseInt(form.total_points * (form.time_quality / 100)) }} 分</span>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col class="gutter-row" :span="12">
          <a-form-model-item label="人均工作量(分值占比)" prop="average_workload">
            <a-input-number v-model="form.average_workload" :min="0" :max="100" :formatter="value => `${value}%`" :parser="value => value.replace('%', '')" style="width: 60%" />
            <span> {{ parseInt(form.total_points * (form.average_workload / 100)) }} 分</span>
          </a-form-model-item>
        </a-col>
        <a-col class="gutter-row" :span="12" :label-col="{ span: 5 }" :wrapper-col="{ span: 5 }">
          <a-form-model-item label="提审通过率(分值占比)" prop="release_passed">
            <a-input-number v-model="form.release_passed" :min="0" :max="100" :formatter="value => `${value}%`" :parser="value => value.replace('%', '')" style="width: 60%" />
            <span> {{ parseInt(form.total_points * (form.release_passed / 100)) }} 分</span>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col class="gutter-row" :span="12">
          <a-form-model-item label="缺陷响应时长(分值占比)" prop="response_time">
            <a-input-number v-model="form.response_time" :min="0" :max="100" :formatter="value => `${value}%`" :parser="value => value.replace('%', '')" style="width: 60%" />
            <span> {{ parseInt(form.total_points * (form.response_time / 100)) }} 分</span>
          </a-form-model-item>
        </a-col>
        <a-col class="gutter-row" :span="12" :label-col="{ span: 5 }" :wrapper-col="{ span: 5 }">
          <a-form-model-item label="缺陷密度(分值占比)" prop="defect_density">
            <a-input-number v-model="form.defect_density" :min="0" :max="100" :formatter="value => `${value}%`" :parser="value => value.replace('%', '')" style="width: 60%" />
            <span> {{ parseInt(form.total_points * (form.defect_density / 100)) }} 分</span>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col class="gutter-row" :span="24">
          <a-form-model-item label="备注信息">
            <a-input v-model="form.description" type="textarea" />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
  </a-modal>
</template>

<script>
import { projectList } from '@/api/project/project';
import { teamList } from '@/api/system/team';
import { noticeboardAdd, noticeboardEdit } from '@/api/data/noticeboard';
export default {
  props: {
    display: {
      type: Boolean,
      default: false
    },
    sourceId: {
      type: [String, Number],
      default: null
    },
    sourceData: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      visible: false,
      loading: false,
      projects: [],
      teams: [],
      form: {
        title: null,
        teams: [],
        projects: [],
        start_date: null,
        end_date: null,
        description: null,
        total_points: null,
        time_quality: null,
        average_workload: null,
        release_passed: null,
        response_time: null,
        defect_density: null
      },
      params: {
        teams: [1, 2, 3, 4, 5, 6, 8, 9],
        total_points: 80,
        time_quality: 25,
        average_workload: 10,
        release_passed: 30,
        response_time: 20,
        defect_density: 15
      },
      rules: {
        title: [{ required: true, message: '看板标题不能为空', trigger: 'blur' }],
        teams: [{ required: true, message: '参与团队不能为空', trigger: 'blur' }],
        projects: [{ required: true, message: '参与项目不能为空', trigger: 'blur' }],
        start_date: [{ required: true, message: '开始日期不能为空', trigger: 'blur' }],
        end_date: [{ required: true, message: '结束日期不能为空', trigger: 'blur' }],
        total_points: [{ required: true, message: '总分不能为空', trigger: 'blur' }],
        time_quality: [{ required: true, message: '时量分布(分值占比)不能为空', trigger: 'blur' }],
        average_workload: [{ required: true, message: '平均工作量(分值占比)不能为空', trigger: 'blur' }],
        release_passed: [{ required: true, message: '提审通过率(分值占比)不能为空', trigger: 'blur' }],
        response_time: [{ required: true, message: '缺陷响应时长(分值占比)不能为空', trigger: 'blur' }],
        defect_density: [{ required: true, message: '缺陷密度(分值占比)不能为空', trigger: 'blur' }]
      }
    };
  },
  watch: {
    display() {
      this.visible = this.display;
      if (this.visible === true) {
        this.getTeamtList();
        this.getProjectList();
        if (this.sourceId !== null) {
          this.form = {
            ...this.sourceData,
            ...this.sourceData.params,
            projects: this.sourceData.projects ? this.sourceData.projects.map(item => item.id) : []
          };
        } else {
          this.form = { ...this.params, projects: [] };
        }
      }
    }
  },
  methods: {
    close(type) {
      this.$emit('close', type);
    },

    // 获取项目列表
    getProjectList() {
      projectList({}).then(res => {
        this.projects = res.data.projects;
      });
    },

    // 获取项目列表
    getTeamtList() {
      teamList({}).then(res => {
        this.teams = res.data.items;
      });
    },

    onBlur(item) {
      this.$refs.form.validateField([item]);
    },

    onSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          const request = {
            title: this.form.title,
            projects: this.form.projects,
            start_date: this.form.start_date,
            end_date: this.form.end_date,
            description: this.form.description,
            params: {
              teams: this.form.teams,
              total_points: this.form.total_points,
              time_quality: this.form.time_quality,
              average_workload: this.form.average_workload,
              release_passed: this.form.release_passed,
              response_time: this.form.response_time,
              defect_density: this.form.defect_density
            }
          };
          this.loading = true;
          if (this.sourceId === null) {
            noticeboardAdd(request)
              .then(() => {
                this.loading = false;
                this.close('submit');
              })
              .catch(() => {
                this.loading = false;
              });
          } else {
            noticeboardEdit({ id: this.sourceId, ...request })
              .then(() => {
                this.loading = false;
                this.close('submit');
              })
              .catch(() => {
                this.loading = false;
              });
          }
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
/deep/.ant-form-item {
  margin-bottom: 0;
}
</style>
